import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { media } from 'styles';
import { sp } from 'styles/theme';
import mixins from 'styles/mixins';
import { Breadcrumbs, TypingHero, StaticHero } from 'components/shared';

const StyledHeader = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin-bottom: ${sp.xl};
  padding: 0 ${sp.m};
  height: 320px;

  ${media.tablet`
    background-size: cover;
    background-position: left;
    background-image: url('${props => props.src}');
    background-repeat: no-repeat;
    height: 400px;
  `};
`;

const Headings = styled.div`
  ${mixins.heroText};
  margin-bottom: ${sp.xl};
  margin-top: 20px;
  text-align: center;
`;

const Subheading = styled.div`
  h3 {
    ${media.tablet`
      margin: 0 auto;
      line-height: 37px;
      width: 50%;
    `};
    font-size: 24px;
  }
`;

function Header({ heading, subheading, slug, image, heroTypingValues }) {
  const breadcrumbs = [
    {
      name: 'Home',
      link: '/',
    },
    {
      name: heading,
      link: `/${slug}`,
    },
  ];
  return (
    <StyledHeader
      src={
        image.responsiveResolution
          ? image.responsiveResolution.src
          : image.file.url
      }
    >
      <Breadcrumbs breadcrumbs={breadcrumbs} />
      <Headings>
        {heroTypingValues ? (
          <TypingHero heading={heading} lines={heroTypingValues.split(',')} />
        ) : (
          <StaticHero heading={heading} />
        )}
        <Subheading>
          <h3>{subheading}</h3>
        </Subheading>
      </Headings>
    </StyledHeader>
  );
}

Header.propTypes = {
  heading: PropTypes.string.isRequired,
  subheading: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
  image: PropTypes.shape({}).isRequired,
  heroTypingValues: PropTypes.string.isRequired,
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/PagePage/components/Header/Header.jsx